import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from '@/config/theme';
import ResponsiveQueryProvider from '@/components/ResponsiveQueryProvider';

const AppProviders: React.FunctionComponent<AppProvidersProps> = ({ children }) => {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ResponsiveQueryProvider>
        {children}
      </ResponsiveQueryProvider>
    </ThemeProvider>
  );
};

interface AppProvidersProps {
  children: React.ReactNode;
}

export default AppProviders;
